import React, { useEffect, useState, useRef } from 'react'
import { Button, Card, CardContent, CardMedia, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Tab, Tabs, Typography } from '@mui/material'
import oAuthServiceConfig from 'src/app/auth/services/oAuthService/oAuthServiceConfig'
import OAuthService from 'src/app/auth/services/oAuthService';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon';
// import NewRequestFormPopup from './NewRequestFormPopup';
import newImage from 'src/assets/new-product.png'
import SHR from 'src/assets/shr.png'
import MOU from 'src/assets/mou.png'
import RET from 'src/assets/ret.png'
import PRJ from 'src/assets/prj.png'
import MISC from 'src/assets/misc.png'
import { useNavigate } from 'react-router-dom';
import ShowroomQuestinaries from './ShowroomQuestinaries';
// import DemoBook from './PageFlip'
import Steps from './Steps';
import RevisionRequest from './RevisionRequest';
import ListPageHeader from '../utilities/ListPageHeader';
import RETMOUQuestinaries from './RETMOUQuestinaries';
import PRJRequest from './PRJRequest';
import MISCRequest from './MISCRequest';

const RequestTypes = () => {
    const childRef = useRef();
    const [tabValue, setTabValue] = useState(0);
    const [open, setOpen] = useState(false);
    const [requestType, setRequestType] = useState();
    const [formData, setFormData] = useState();
    const [status, setStatus] = useState();
    const [designStudioCategory, setDesignStudioCategory] = useState();
    const [showPaginationDropdown, setShowPaginationDropdown] = useState(false);
    const dsTask = JSON.parse(localStorage.getItem('dsTask'));
    const backAction = localStorage.getItem('backAction')
    const requestTypes = [
        { title: 'SHR', name: 'Showroom', image: SHR },
        { title: 'MOU', name: 'Mockup', image: MOU },
        { title: 'RET', name: 'Retail', image: RET },
        { title: 'PRJ', name: 'Project', image: PRJ },
        { title: 'MISC', name: 'Misc', image: MISC }
    ]

    const handleTabChange = (event, value) => {
        setTabValue(value);
    }

    const handleClose = () => {
        localStorage.removeItem('dsTask');
        localStorage.removeItem('backAction')
        setOpen(false);
    };

    const handleSave = () => {
        console.log("save");
        const childelement = childRef.current;
        console.log('childelement', childelement)
        const submitData = childelement.handleSubmit();
        console.log("submitData", submitData)
        submitData.then((val) => {
            if (val) {
                console.log(val, "val")
                setOpen(false);
                // loadData();
            } else {
                console.log("else");
            }
            // setOpen(false)
            // navigate('/new-request-calendar')
            // setTabValue(1)
        }).catch((error) => console.log(error))
    }

    const handleSaveAsDraftOrSendPartner = () => {
        localStorage.removeItem('backAction')
        // localStorage.setItem('backAction', false) 
        const childelement = childRef.current;
        const submitData = childelement.handleSaveDraft();
        submitData.then((val) => {
            if (val) {
                console.log(val, "val")
                setOpen(false);
                // loadData();
            } else {
                console.log("else");
            }
            setOpen(false)
            // navigate('/new-request-calendar')
            // setTabValue(1)
        }).catch((error) => console.log(error))
    }

    const handleCardClick = (value) => {
        setRequestType(value.name)
        setDesignStudioCategory(value.title)
        setOpen(true)
    }


    const checkedStatus = (st) => {
        setStatus(st)
    }

    useEffect(() => {
        checkedStatus()
    }, [])

    useEffect(() => {
        if (backAction == true || backAction == "true") {
            if (dsTask) {
                setOpen(true)
                // localStorage.setItem('backAction', false)
            }
        }
    }, [backAction])

    return (
        <>
            <ListPageHeader
                componentName="Request Types"
                pageName="Request Types"
                showPaginationDropdown={showPaginationDropdown}
            />
            <div className='bg-[#2a2e32] sticky mt-20 mb-20 mr-20 ml-20 '>
                <Tabs
                    value={tabValue}
                    textColor="inherit"
                    onChange={handleTabChange}
                    indicatorColor="primary"
                    sx={{ color: "yellow" }}
                    variant="scrollable"
                    scrollButtons="auto"
                >
                    <Tab className="h-64" label="New Request" sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }} />
                    <Tab className="h-64" label="Revision Request" sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }} />
                </Tabs>
            </div>
            {tabValue === 0 ? (
                <div className='flex'>
                    {requestTypes?.map((obj, i) => (
                        <Card key={i} className={`hover:bg-orange-400 hover:text-white m-20 w-1/4 h-auto border border-solid border-orange-400 cursor-pointer `} onClick={() => handleCardClick(obj)}>
                            <CardContent className='hover:text-white text-orange-400 hover:text-white text-center text-2xl text-semibold'
                                style={{ textAlign: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', padding: '50px' }}
                                key={i}>
                                {/* <div> */}
                                    <img alt={obj.title} src={obj.image} className='w-64 h-64'></img>
                                {/* </div> */}
                                <div className='mt-20'>{obj.title}</div>
                            </CardContent>
                        </Card>
                    ))}
                </div>
            ) : (
                <RevisionRequest />
            )}

            <Dialog
                fullWidth={true}
                maxWidth={'lg'}
                onClose={handleClose}
                open={open}
            // {...other}
            >
                <DialogTitle>
                    <div className="flex flex-col sm:flex-row space-y-16 sm:space-y-0">
                        <span>{requestType}</span>
                        <div className="flex flex-col w-full sm:w-auto sm:flex-row space-y-16 sm:space-y-0 flex-1 items-center justify-end space-x-8">
                            {/* <Button variant="contained" color="warning" onClick={handleSave} ><FuseSvgIcon>heroicons-solid:document</FuseSvgIcon></Button> */}
                            <Button onClick={handleClose}><FuseSvgIcon>heroicons-solid:x</FuseSvgIcon></Button>
                        </div>
                    </div>
                </DialogTitle>
                {/* {(dsTask?.designStudioCategory === 'SHR' || designStudioCategory === 'SHR') && (
                    <> */}
                        <DialogContent dividers>
                            {designStudioCategory === 'SHR' && <ShowroomQuestinaries ref={childRef} checkedStatus={checkedStatus} designStudioCategory={dsTask?.designStudioCategory || designStudioCategory} />}
                            {(designStudioCategory === "RET" || designStudioCategory === "MOU") && <RETMOUQuestinaries ref={childRef} checkedStatus={checkedStatus} designStudioCategory={dsTask?.designStudioCategory || designStudioCategory} />}
                            {designStudioCategory === "PRJ" && <PRJRequest ref={childRef} checkedStatus={checkedStatus} designStudioCategory={dsTask?.designStudioCategory || designStudioCategory} />}
                            {designStudioCategory === "MISC" && <MISCRequest ref={childRef} checkedStatus={checkedStatus} designStudioCategory={dsTask?.designStudioCategory || designStudioCategory} />}
                        </DialogContent>
                        <DialogActions className='flex justify-center '>
                            <div className='flex justify-center items-center space-x-8'>
                                <Button variant="outlined" color="warning" onClick={handleSaveAsDraftOrSendPartner}>Send to Partner </Button>
                                <Button variant="outlined" color="warning" onClick={handleSaveAsDraftOrSendPartner}>Save as draft</Button>
                                <Button variant="contained" color="warning"
                                    onClick={handleSave}
                                    disabled={status}
                                >Submit</Button>
                            </div>
                        </DialogActions>
                    {/* </>
                )} */}
            </Dialog>
        </>
    )
}

export default RequestTypes